import type { ChartOptions } from "chart.js";

// The analytics chart cards take their height from their container. On the
// other analytics pages a taller sibling card in the same row provides it;
// here charts are stacked, so each one gets an explicit plot height and its
// card grows around it, or Chart.js falls back to its 150px default canvas
// and squeezes the bars.

export const BAR_THICKNESS = 14;

/** Legend and value axis drawn inside the canvas. */
const CANVAS_CHROME = 56;

/** Horizontal bars of the fixed thickness `hbarPlotHeight` counts on. */
export const barChartOptions: Partial<ChartOptions<"bar">> = {
  datasets: { bar: { barThickness: BAR_THICKNESS } },
};

/** Plot height that fits `dataHeight` px of bars or lines, legend and axis included. */
export const chartPlotHeight = (dataHeight: number): number =>
  CANVAS_CHROME + dataHeight;

/** Plot height of a horizontal bar chart with `series` bars per row. */
export const hbarPlotHeight = (rows: number, series: number): number =>
  chartPlotHeight(rows * (series * (BAR_THICKNESS + 4) + 16));
